<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  <ng-container *ngIf="data.allowOptionalComment; else addCommentMode">
    <app-data-exchange-comments
      [comments]="data.comments"
      [canAddComment]="false">
    </app-data-exchange-comments>

    <div class="add-comment">
      <mat-form-field appearance="outline" class="full-width comment-form-field">
        <mat-label>{{ 'dataManagement.dataExchangeRequests.comments.addComment' | transloco }}</mat-label>
        <textarea matInput class="no-resize-textarea" [formControl]="commentControl"></textarea>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-template #addCommentMode>
    <app-data-exchange-comments
      [comments]="data.comments"
      (commentAdded)="onCommentAdded($event)">
    </app-data-exchange-comments>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>
    {{ 'common.buttons.close' | transloco }}
  </button>
  <button *ngIf="data.allowOptionalComment" mat-raised-button color="primary" type="button" (click)="onConfirm()">
    {{ (data.confirmButtonTranslationKey || 'common.buttons.confirm') | transloco }}
  </button>
</mat-dialog-actions>
